/* Tolstoy carousel two column (custom UI) */
(function () {
  function qs(el, sel) {
    return el ? el.querySelector(sel) : null;
  }

  function qsa(el, sel) {
    return el ? Array.from(el.querySelectorAll(sel)) : [];
  }

  function tolstoyCarouselSearchRoot(carouselEl) {
    if (carouselEl && carouselEl.shadowRoot) return carouselEl.shadowRoot;
    return carouselEl;
  }

  function largerImageUrl(url, w) {
    if (!url || typeof url !== 'string') return url;
    var out = url;
    if (/[?&]width=\d+/i.test(out)) {
      out = out.replace(/([?&])width=\d+/gi, '$1width=' + w);
    } else if (out.indexOf('cdn.shopify.com') !== -1 || out.indexOf('shopifycdn.net') !== -1) {
      out = out + (out.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    return out;
  }

  function normalizeText(s) {
    return String(s || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function extractProductHandle(tile) {
    var el = tile.querySelector('[data-product-handle]');
    return el ? String(el.getAttribute('data-product-handle') || '').trim() : '';
  }

  function extractVariantIdFromTile(tile) {
    var root = tile.querySelector('[data-tolstoy-product-tile]');
    var key = root && root.getAttribute('data-tolstoy-product-tile');
    if (key) {
      var parts = key.split('-');
      var last = parts[parts.length - 1];
      if (/^\d{6,}$/.test(last)) return last;
    }
    var withAttr = tile.querySelector('[data-variant-id],[data-variantid]');
    if (withAttr) {
      return String(withAttr.getAttribute('data-variant-id') || withAttr.getAttribute('data-variantid') || '').trim();
    }
    return '';
  }

  function extractPriceTextFromTile(tile) {
    var priceEl = tile.querySelector('.tolstoy-product-tile-price');
    if (priceEl) {
      var t = normalizeText(priceEl.innerText || priceEl.textContent);
      if (t) return t;
    }
    var alt = tile.querySelector('[class*="product-tile-price"],[class*="ProductTilePrice"]');
    if (alt) {
      t = normalizeText(alt.innerText || alt.textContent);
      if (t) return t;
    }
    var sub = tile.querySelector('.tolstoy-product-tile-subtitle');
    if (sub) {
      t = normalizeText(sub.innerText || sub.textContent);
      if (t && /[\d$£€]|AUD|USD|GBP|EUR/i.test(t)) return t;
    }
    return '';
  }

  function extractSlides(carouselEl) {
    var searchRoot = tolstoyCarouselSearchRoot(carouselEl);
    if (!searchRoot) return [];

    var tiles = searchRoot.querySelectorAll('[data-tolstoy-element^="tolstoy-carousel-tile-container"]');
    if (!tiles.length) {
      tiles = searchRoot.querySelectorAll('.tolstoy-carousel-videos-container > div[role="group"]');
    }

    var seen = {};
    var out = [];
    tiles.forEach(function (tile) {
      var videoId =
        tile.getAttribute('data-tolstoy-video-id') ||
        (tile.querySelector('[data-tolstoy-video-id]') &&
          tile.querySelector('[data-tolstoy-video-id]').getAttribute('data-tolstoy-video-id')) ||
        '';
      if (videoId && seen[videoId]) return;
      if (videoId) seen[videoId] = true;

      var handle = extractProductHandle(tile);
      if (!videoId && handle && seen['handle:' + handle]) return;
      if (!videoId && handle) seen['handle:' + handle] = true;

      var vc = tile.querySelector('.tolstoy-carousel-video-container');
      var video = vc ? vc.querySelector('video.tolstoy-carousel-video') || vc.querySelector('video') : tile.querySelector('video');
      var carouselImg = vc ? vc.querySelector('img.tolstoy-carousel-image') || vc.querySelector('img') : null;
      var productImg = tile.querySelector('.tolstoy-product-tile-image');
      var titleEl = tile.querySelector('.tolstoy-product-tile-title');

      var videoSrc = '';
      if (video) videoSrc = video.getAttribute('src') || video.currentSrc || '';
      var poster = (video && video.getAttribute('poster')) || '';
      var rawThumb =
        (productImg && productImg.getAttribute('src')) ||
        (carouselImg && carouselImg.getAttribute('src')) ||
        poster ||
        '';
      if (!videoSrc && !rawThumb) return;

      out.push({
        videoSrc: videoSrc,
        poster: poster,
        thumb: rawThumb,
        title: titleEl ? normalizeText(titleEl.innerText || titleEl.textContent) : '',
        price: extractPriceTextFromTile(tile),
        handle: handle || '',
        variantId: extractVariantIdFromTile(tile)
      });
    });
    return out;
  }

  function productUrl(root, handle) {
    if (!handle) return '';
    var base = (root.getAttribute('data-routes-root') || '/').replace(/\/$/, '');
    return base + '/products/' + encodeURIComponent(handle);
  }

  var variantCache = {};

  function resolveVariantId(root, slide) {
    if (slide.handle) {
      if (variantCache[slide.handle]) {
        return Promise.resolve(variantCache[slide.handle]);
      }
      var routesRoot = root.getAttribute('data-routes-root') || '/';
      return fetch(routesRoot.replace(/\/$/, '') + '/products/' + encodeURIComponent(slide.handle) + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error();
          return res.json();
        })
        .then(function (product) {
          var v = product && product.variants && product.variants[0];
          var vid = v ? String(v.id) : null;
          if (vid) variantCache[slide.handle] = vid;
          return vid;
        })
        .catch(function () {
          return null;
        });
    }
    if (slide.variantId) return Promise.resolve(slide.variantId);
    return Promise.resolve(null);
  }

  function addToBag(root, btn, slide) {
    var originalText = btn.textContent;

    function flashError() {
      btn.textContent = 'Could not add';
      btn.disabled = true;
      window.setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }

    function doAdd(variantId) {
      if (!variantId) {
        console.warn('[Tolstoy two-col] No variant ID found for', slide.handle);
        flashError();
        return;
      }
      btn.disabled = true;
      btn.textContent = 'Adding…';

      var routesRoot = root.getAttribute('data-routes-root') || '/';
      var addUrl = (window.routes && window.routes.cart_add_url) || routesRoot.replace(/\/$/, '') + '/cart/add.js';
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (r) {
          var data = r.data;
          if (data.status || data.errors) {
            flashError();
            return;
          }

          btn.textContent = 'Added ✓';
          window.setTimeout(function () {
            btn.textContent = originalText;
          }, 1500);

          var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

          fetch(cartUrl + '?section_id=cart-drawer')
            .then(function (res) {
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var freshDrawer = doc.querySelector('#CartDrawer');
              var liveDrawer = document.querySelector('#CartDrawer');
              if (freshDrawer && liveDrawer) liveDrawer.innerHTML = freshDrawer.innerHTML;
              var freshBubble = doc.querySelector('#cart-icon-bubble');
              if (freshBubble) {
                var liveBubble = document.getElementById('cart-icon-bubble');
                if (liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
              }
            })
            .catch(function () {})
            .finally(function () {
              if (cart) {
                cart.classList.remove('is-empty');
                var drawerInner = cart.querySelector('.drawer__inner');
                if (drawerInner) drawerInner.classList.remove('is-empty');
                if (typeof cart.open === 'function') cart.open();
              }
            });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              productVariantId: String(variantId),
              cartData: data
            });
          }
        })
        .catch(function (err) {
          console.warn('[Tolstoy two-col] Cart add failed:', err);
          flashError();
        })
        .finally(function () {
          btn.disabled = false;
        });
    }

    btn.disabled = true;
    resolveVariantId(root, slide).then(function (vid) {
      doAdd(vid);
    });
  }

  function getCardImageWidth(root) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      return Number(root.getAttribute('data-card-image-width-mobile')) || Number(root.getAttribute('data-card-image-width')) || 600;
    }
    return Number(root.getAttribute('data-card-image-width')) || 960;
  }

  function getProductThumbImageWidth(root) {
    var displaySize = Number(root.getAttribute('data-product-thumb-size-mobile')) || 70;
    return Math.max(displaySize, Math.round(displaySize * 2));
  }

  var AUDIO_ICON_MUTED =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z"/>' +
    '</svg>';
  var AUDIO_ICON_UNMUTED =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>' +
    '</svg>';
  var videoAudioDetectCache = {};

  function getVideoSourceKey(video) {
    return (video.currentSrc || video.getAttribute('src') || video.src || '').trim();
  }

  function probeVideoHasAudio(video) {
    if (video.audioTracks && video.audioTracks.length > 0) return true;
    if (typeof video.mozHasAudio === 'boolean') return video.mozHasAudio;
    if (typeof video.webkitAudioDecodedByteCount === 'number' && video.webkitAudioDecodedByteCount > 0) return true;
    try {
      if (typeof video.captureStream === 'function') {
        return video.captureStream().getAudioTracks().length > 0;
      }
    } catch (_) {}
    return null;
  }

  function detectVideoHasAudio(video) {
    var src = getVideoSourceKey(video);
    if (!src) return Promise.resolve(false);
    if (Object.prototype.hasOwnProperty.call(videoAudioDetectCache, src)) {
      return Promise.resolve(videoAudioDetectCache[src]);
    }

    var immediate = probeVideoHasAudio(video);
    if (immediate === true) {
      videoAudioDetectCache[src] = true;
      return Promise.resolve(true);
    }
    if (immediate === false && typeof video.mozHasAudio === 'boolean') {
      videoAudioDetectCache[src] = false;
      return Promise.resolve(false);
    }

    return new Promise(function (resolve) {
      var settled = false;
      var wasPaused = video.paused;
      var wasMuted = video.muted;
      var wasTime = video.currentTime;

      function finish(hasAudio) {
        if (settled) return;
        settled = true;
        cleanup();
        videoAudioDetectCache[src] = hasAudio;
        // The probe plays the video to sniff for an audio track. Only undo that if nothing
        // has since asked this tile to keep playing (active tile, hover, on-load) — otherwise
        // autoplay never sticks on the tile that's already active when the probe first runs.
        if (wasPaused && !video._ttcWantsPlay) {
          try {
            video.pause();
            video.currentTime = wasTime;
          } catch (_) {}
        }
        video.muted = wasMuted;
        resolve(hasAudio);
      }

      function cleanup() {
        video.removeEventListener('loadeddata', onLoadedData);
        video.removeEventListener('playing', onPlaying);
      }

      function runProbe() {
        var result = probeVideoHasAudio(video);
        if (result === true) {
          finish(true);
          return;
        }
        if (result === false && typeof video.mozHasAudio === 'boolean') {
          finish(false);
          return;
        }

        video.muted = true;
        video.addEventListener('playing', onPlaying, { once: true });
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            finish(false);
          });
        }

        window.setTimeout(function () {
          if (settled) return;
          var late = probeVideoHasAudio(video);
          finish(late === true);
        }, 250);
      }

      function onPlaying() {
        window.setTimeout(function () {
          if (settled) return;
          var result = probeVideoHasAudio(video);
          finish(result === true);
        }, 120);
      }

      function onLoadedData() {
        runProbe();
      }

      if (video.readyState >= 2) {
        runProbe();
      } else {
        video.addEventListener('loadeddata', onLoadedData, { once: true });
      }

      window.setTimeout(function () {
        if (!settled) finish(false);
      }, 4000);
    });
  }

  function ensureAudioDetected(video) {
    if (video._ttcAudioChecked) return;
    video._ttcAudioChecked = true;
    detectVideoHasAudio(video).then(function (hasAudio) {
      var media = video.closest('.tolstoy-two-col__media');
      if (!media || !media.isConnected) return;
      applyAudioToggleForVideo(video, hasAudio);
    });
  }

  function applyAudioToggleForVideo(video, hasAudio) {
    var media = video.closest('.tolstoy-two-col__media');
    if (!media) return;

    video.setAttribute('data-has-audio', hasAudio ? 'true' : 'false');
    var btn = media.querySelector('.tolstoy-two-col__audio-toggle');

    if (!hasAudio) {
      if (btn) btn.remove();
      return;
    }

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tolstoy-two-col__audio-toggle';
      media.appendChild(btn);
    }

    updateAudioToggleButton(btn, video);
    btn.hidden = false;
  }

  function updateAudioToggleButton(btn, video) {
    var isMuted = video.muted;
    btn.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
    btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    btn.setAttribute('data-audio-state', isMuted ? 'muted' : 'unmuted');
    btn.innerHTML = isMuted ? AUDIO_ICON_MUTED : AUDIO_ICON_UNMUTED;
  }

  function initVideoAudioToggle(media, video) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tolstoy-two-col__audio-toggle';
    btn.hidden = true;
    media.appendChild(btn);
    // Give it a real accessible name immediately (based on the video's current muted state)
    // so it's never announced as a bare "button" — even though it stays hidden until we know
    // the video has audio. Detection of *whether* it has audio is still deferred (see
    // ensureAudioDetected) until this video is actually about to play, instead of probing
    // every tile's audio on load.
    updateAudioToggleButton(btn, video);
  }

  function syncCloneAudioToggle(clone, sourceCard) {
    var video = clone.querySelector('video');
    if (!video) return;

    var src = getVideoSourceKey(video);
    if (src && Object.prototype.hasOwnProperty.call(videoAudioDetectCache, src)) {
      applyAudioToggleForVideo(video, videoAudioDetectCache[src]);
      return;
    }

    var sourceVideo = sourceCard && sourceCard.querySelector('video');
    var state = sourceVideo && sourceVideo.getAttribute('data-has-audio');
    if (state === 'true' || state === 'false') {
      applyAudioToggleForVideo(video, state === 'true');
      return;
    }

    detectVideoHasAudio(video).then(function (hasAudio) {
      if (!video.isConnected) return;
      applyAudioToggleForVideo(video, hasAudio);
    });
  }

  function muteAllVideosInGrid(grid, exceptVideo) {
    qsa(grid, 'video').forEach(function (video) {
      if (video === exceptVideo) return;
      video.muted = true;
      var media = video.closest('.tolstoy-two-col__media');
      var btn = media && media.querySelector('.tolstoy-two-col__audio-toggle');
      if (btn) updateAudioToggleButton(btn, video);
    });
  }

  function setupAudioToggleDelegation(grid) {
    if (grid._ttcAudioBound) return;
    grid._ttcAudioBound = true;
    grid.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.tolstoy-two-col__audio-toggle');
      if (!btn || !grid.contains(btn)) return;
      ev.preventDefault();
      ev.stopPropagation();
      var media = btn.closest('.tolstoy-two-col__media');
      var video = media && media.querySelector('video');
      if (!video) return;

      if (video.muted) {
        muteAllVideosInGrid(grid, video);
        video.muted = false;
        video.play().catch(function () {});
      } else {
        video.muted = true;
      }
      updateAudioToggleButton(btn, video);
    });
  }

  function bindMediaHover(card, video) {
    if (card._ttcHoverBound) return;
    card._ttcHoverBound = true;
    card.addEventListener('mouseenter', function () {
      video._ttcWantsPlay = true;
      ensureAudioDetected(video);
      video.play().catch(function () {});
    });
    card.addEventListener('mouseleave', function () {
      video._ttcWantsPlay = false;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (_) {}
    });
  }

  function updateProductPanel(root, slides, idx) {
    var panel = qs(root, '.tolstoy-two-col__product');
    if (!panel) return;

    if (!isMobileGrid()) {
      panel.hidden = false;
      panel.innerHTML = '';
      return;
    }

    var slide = slides[idx];
    if (!slide || (!slide.title && !slide.price && !slide.handle)) {
      panel.hidden = true;
      panel.innerHTML = '';
      return;
    }

    var href = productUrl(root, slide.handle);
    var thumbSrc = slide.thumb || slide.poster || '';
    var thumbImageWidth = getProductThumbImageWidth(root);
    var addToBagLabel = (root.getAttribute('data-add-to-bag-label') || 'Add to bag').trim();
    var priceTrim = slide.price ? slide.price.replace(/\s+/g, ' ').trim() : '';
    if (thumbSrc) thumbSrc = largerImageUrl(thumbSrc, thumbImageWidth);

    panel.hidden = false;
    panel.innerHTML = '';

    var inner = document.createElement('div');
    inner.className = 'tolstoy-two-col__product-inner';

    var row = document.createElement('div');
    row.className = 'tolstoy-two-col__product-row';

    var linkWrap = document.createElement('div');
    linkWrap.className = 'tolstoy-two-col__product-link';

    if (thumbSrc) {
      if (href) {
        var thumbLink = document.createElement('a');
        thumbLink.className = 'tolstoy-two-col__product-thumb-link';
        thumbLink.href = href;
        var img = document.createElement('img');
        img.className = 'tolstoy-two-col__product-thumb';
        img.src = thumbSrc;
        img.alt = slide.title || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        thumbLink.appendChild(img);
        linkWrap.appendChild(thumbLink);
      } else {
        var imgOnly = document.createElement('img');
        imgOnly.className = 'tolstoy-two-col__product-thumb';
        imgOnly.src = thumbSrc;
        imgOnly.alt = slide.title || '';
        imgOnly.loading = 'lazy';
        imgOnly.decoding = 'async';
        linkWrap.appendChild(imgOnly);
      }
    }

    var meta = document.createElement('div');
    meta.className = 'tolstoy-two-col__product-meta';

    if (slide.title) {
      if (href) {
        var titleLink = document.createElement('a');
        titleLink.className = 'tolstoy-two-col__product-title';
        titleLink.href = href;
        titleLink.textContent = slide.title;
        meta.appendChild(titleLink);
      } else {
        var title = document.createElement('p');
        title.className = 'tolstoy-two-col__product-title';
        title.textContent = slide.title;
        meta.appendChild(title);
      }
    }

    if (priceTrim) {
      var price = document.createElement('p');
      price.className = 'tolstoy-two-col__product-price';
      price.textContent = priceTrim;
      meta.appendChild(price);
    }

    if (slide.handle) {
      var cta = document.createElement('button');
      cta.type = 'button';
      cta.className = 'tolstoy-two-col__product-cta button button--primary';
      cta.textContent = addToBagLabel;
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        addToBag(root, cta, slide);
      });
      meta.appendChild(cta);
    }

    linkWrap.appendChild(meta);
    row.appendChild(linkWrap);
    inner.appendChild(row);

    panel.appendChild(inner);
  }

  function clampMax(slides, maxCards) {
    var n = Number(maxCards) || 0;
    if (!n || n <= 0) return slides;
    return slides.slice(0, n);
  }

  function createTolstoyCarousel(publishId, productId) {
    var el = document.createElement('tolstoy-carousel');
    el.className = 'tolstoy-carousel';
    el.id = publishId;
    el.setAttribute('data-publish-id', publishId);
    if (productId) el.setAttribute('data-product-id', productId);
    return el;
  }

  function isMobileGrid() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSlideIndex(card) {
    if (!card) return 0;
    var idx = Number(card.getAttribute('data-slide-index'));
    return isNaN(idx) ? 0 : idx;
  }

  function getSlideCount(grid) {
    return Number(grid.getAttribute('data-slide-count')) || 0;
  }

  function getClosestCard(grid) {
    var cards = qsa(grid, '.tolstoy-two-col__card');
    if (!cards.length) return null;
    var center = grid.scrollLeft + grid.clientWidth / 2;
    var closest = cards[0];
    var closestDist = Infinity;
    cards.forEach(function (card) {
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      var d = Math.abs(cardCenter - center);
      if (d < closestDist) {
        closestDist = d;
        closest = card;
      }
    });
    return closest;
  }

  function findActiveIndexFromScroll(grid) {
    var cards = qsa(grid, '.tolstoy-two-col__card:not([data-clone="true"])');
    if (!cards.length) return 0;

    if (isMobileGrid()) {
      var closest = getClosestCard(grid);
      return closest ? getSlideIndex(closest) : 0;
    }

    var scrollPos = grid.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    cards.forEach(function (card) {
      var dist = Math.abs(card.offsetLeft - scrollPos);
      if (dist < bestDist) {
        bestDist = dist;
        best = getSlideIndex(card);
      }
    });
    return best;
  }

  function setActive(grid, bulletsWrap, idx) {
    var root = grid.closest('.tolstoy-two-col');
    var slides = root && root._ttcSlides ? root._ttcSlides : [];
    var cards = qsa(grid, '.tolstoy-two-col__card');
    cards.forEach(function (c) {
      c.setAttribute('data-active', getSlideIndex(c) === idx ? 'true' : 'false');
    });
    var bullets = qsa(bulletsWrap, '.tolstoy-two-col__bullet');
    bullets.forEach(function (b, i) {
      b.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    if (root) {
      updateProductPanel(root, slides, idx);
    }
  }

  function updateActivePlayback(root, grid, activeIdx) {
    var mobile = isMobileGrid();
    var mode = (root.getAttribute('data-desktop-video-playback') || 'hover').trim();

    // Desktop "on_load" autoplays every tile at once by design (a merchant setting) and
    // "hover" only plays on pointer hover — neither needs active-tile management here.
    // Mobile always plays just the active tile, same idea as desktop's "active" mode, so a
    // 1.2-tiles-per-view carousel isn't decoding video for every off-screen slide at once.
    if (!mobile && mode !== 'active') return;

    var cards = qsa(grid, '.tolstoy-two-col__card:not([data-clone="true"])');
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      var active = getSlideIndex(card) === activeIdx;
      video._ttcWantsPlay = active;
      if (active) {
        ensureAudioDetected(video);
        try {
          video.play();
        } catch (_) {}
      } else {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (_) {}
      }
    });
  }

  function getCardForIndex(grid, idx) {
    return grid.querySelector('.tolstoy-two-col__card[data-slide-index="' + idx + '"]:not([data-clone="true"])');
  }

  function getScrollTargetForCard(grid, card) {
    if (isMobileGrid()) {
      return card.offsetLeft - (grid.clientWidth - card.offsetWidth) / 2;
    }
    return card.offsetLeft;
  }

  function scrollToCard(grid, card, behavior) {
    if (!card) return;
    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var target = getScrollTargetForCard(grid, card);
    target = Math.max(0, Math.min(target, maxScroll));
    grid.scrollTo({ left: target, behavior: behavior || 'smooth' });
  }

  function scrollToIndex(grid, idx) {
    scrollToCard(grid, getCardForIndex(grid, idx), 'smooth');
  }

  function disableCloneVideos(clone) {
    qsa(clone, 'video').forEach(function (video) {
      video.autoplay = false;
      video.muted = true;
      try {
        video.pause();
      } catch (_) {}
      var media = video.closest('.tolstoy-two-col__media');
      var btn = media && media.querySelector('.tolstoy-two-col__audio-toggle');
      if (btn) updateAudioToggleButton(btn, video);
    });
  }

  function createLoopClone(sourceCard, slideIndex, cloneType) {
    var clone = sourceCard.cloneNode(true);
    clone.classList.add('tolstoy-two-col__card--clone');
    clone.setAttribute('data-clone', 'true');
    clone.setAttribute('data-clone-type', cloneType);
    clone.setAttribute('data-slide-index', String(slideIndex));
    clone.setAttribute('data-active', 'false');
    clone.setAttribute('tabindex', '-1');
    disableCloneVideos(clone);
    syncCloneAudioToggle(clone, sourceCard);
    return clone;
  }

  function reconcileInfiniteScroll(grid, bulletsWrap, root) {
    if (!isMobileGrid()) return findActiveIndexFromScroll(grid);

    var slideCount = getSlideCount(grid);
    if (slideCount < 2) return findActiveIndexFromScroll(grid);

    var closest = getClosestCard(grid);
    if (!closest) return 0;

    var idx = getSlideIndex(closest);
    var cloneType = closest.getAttribute('data-clone-type');
    var realFirst = getCardForIndex(grid, 0);
    var realLast = getCardForIndex(grid, slideCount - 1);

    if (cloneType === 'lead' && realLast) {
      if (grid._ttcSetJumping) grid._ttcSetJumping(true);
      grid.style.scrollBehavior = 'auto';
      scrollToCard(grid, realLast, 'auto');
      grid.style.scrollBehavior = '';
      if (grid._ttcSetJumping) grid._ttcSetJumping(false);
      idx = slideCount - 1;
    } else if (cloneType === 'tail' && realFirst) {
      if (grid._ttcSetJumping) grid._ttcSetJumping(true);
      grid.style.scrollBehavior = 'auto';
      scrollToCard(grid, realFirst, 'auto');
      grid.style.scrollBehavior = '';
      if (grid._ttcSetJumping) grid._ttcSetJumping(false);
      idx = 0;
    }

    setActive(grid, bulletsWrap, idx);
    updateActivePlayback(root, grid, idx);
    return idx;
  }

  function setupMobileCarousel(grid, bulletsWrap, root, slideCount) {
    qsa(grid, '.tolstoy-two-col__card[data-clone="true"]').forEach(function (clone) {
      clone.remove();
    });

    grid.setAttribute('data-slide-count', String(slideCount));
    grid.setAttribute('data-infinite-mobile', slideCount >= 2 ? 'true' : 'false');

    if (!isMobileGrid()) return;

    if (slideCount < 2) {
      requestAnimationFrame(function () {
        grid.style.scrollBehavior = 'auto';
        scrollToIndex(grid, 0);
        grid.style.scrollBehavior = '';
      });
      return;
    }

    var realCards = qsa(grid, '.tolstoy-two-col__card:not([data-clone="true"])');
    var firstCard = realCards[0];
    var lastCard = realCards[realCards.length - 1];
    if (!firstCard || !lastCard) return;

    var leadClone = createLoopClone(lastCard, slideCount - 1, 'lead');
    var tailClone = createLoopClone(firstCard, 0, 'tail');

    grid.insertBefore(leadClone, firstCard);
    grid.appendChild(tailClone);

    function onCloneClick(slideIndex) {
      scrollToIndex(grid, slideIndex);
      setActive(grid, bulletsWrap, slideIndex);
      updateActivePlayback(root, grid, slideIndex);
    }

    leadClone.addEventListener('click', function () {
      onCloneClick(slideCount - 1);
    });
    tailClone.addEventListener('click', function () {
      onCloneClick(0);
    });

    requestAnimationFrame(function () {
      grid.style.scrollBehavior = 'auto';
      scrollToIndex(grid, 0);
      grid.style.scrollBehavior = '';
    });
  }

  function attachScrollHandlers(grid, bulletsWrap, root) {
    var scrollT = null;
    var rafId = null;
    var lastActiveIdx = -1;
    var isJumping = false;

    function updateActiveFromScroll() {
      if (isJumping) return;
      var idx = findActiveIndexFromScroll(grid);
      if (idx === lastActiveIdx) return;
      lastActiveIdx = idx;
      setActive(grid, bulletsWrap, idx);
      updateActivePlayback(root, grid, idx);
    }

    function onScrollSettled() {
      if (isJumping) return;

      if (grid.getAttribute('data-infinite-mobile') === 'true' && isMobileGrid()) {
        lastActiveIdx = reconcileInfiniteScroll(grid, bulletsWrap, root);
        return;
      }

      updateActiveFromScroll();
    }

    grid.addEventListener('scroll', function () {
      if (isMobileGrid()) {
        if (!rafId) {
          rafId = window.requestAnimationFrame(function () {
            rafId = null;
            updateActiveFromScroll();
          });
        }

        if (scrollT) window.clearTimeout(scrollT);
        scrollT = window.setTimeout(onScrollSettled, 40);
        return;
      }

      if (scrollT) window.clearTimeout(scrollT);
      scrollT = window.setTimeout(onScrollSettled, 120);
    }, { passive: true });

    grid.addEventListener('scrollend', function () {
      if (isMobileGrid()) onScrollSettled();
    }, { passive: true });

    grid._ttcSetJumping = function (value) {
      isJumping = value;
    };
  }

  function render(root, slides) {
    var display = qs(root, '.tolstoy-two-col__display');
    var bulletsWrap = qs(root, '.tolstoy-two-col__bullets');
    if (!display || !bulletsWrap) return;

    display.innerHTML = '';
    bulletsWrap.innerHTML = '';

    if (!slides.length) {
      display.innerHTML = '<div class="tolstoy-two-col__loading">No items</div>';
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'tolstoy-two-col__grid';
    grid.setAttribute('role', 'list');
    grid.setAttribute('tabindex', '0');

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var desktopVideoPlayback = (root.getAttribute('data-desktop-video-playback') || 'hover').trim();
    var cardImageWidth = getCardImageWidth(root);

    slides.forEach(function (s, i) {
      var card = document.createElement('div');
      card.className = 'tolstoy-two-col__card';
      card.setAttribute('data-active', i === 0 ? 'true' : 'false');
      card.setAttribute('data-slide-index', String(i));
      card.setAttribute('role', 'listitem');
      card.setAttribute('tabindex', '-1');

      var inner = document.createElement('div');
      inner.className = 'tolstoy-two-col__card-inner';

      var media = document.createElement('div');
      media.className = 'tolstoy-two-col__media';

      if (s.videoSrc) {
        var v = document.createElement('video');
        v.setAttribute('muted', '');
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.loop = true;
        v.preload = 'metadata';
        v.src = s.videoSrc;
        if (s.poster) v.poster = largerImageUrl(s.poster, cardImageWidth);
        if (!isMobile && desktopVideoPlayback === 'on_load') {
          // Explicit merchant choice to play every tile at once; nothing to gate.
          v.autoplay = true;
          v._ttcWantsPlay = true;
          ensureAudioDetected(v);
        }
        // Mobile and desktop "active" mode start playback through updateActivePlayback below,
        // once render() knows which single tile is active — see that call at the end of render().
        media.appendChild(v);
        initVideoAudioToggle(media, v);
        if (!isMobile && desktopVideoPlayback === 'hover') {
          bindMediaHover(card, v);
        }
      } else {
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = '';
        img.src = largerImageUrl(s.thumb || s.poster, cardImageWidth);
        media.appendChild(img);
      }

      inner.appendChild(media);
      card.appendChild(inner);
      grid.appendChild(card);

      card.addEventListener('click', function () {
        scrollToIndex(grid, i);
        setActive(grid, bulletsWrap, i);
        updateActivePlayback(root, grid, i);
      });

      var bullet = document.createElement('button');
      bullet.type = 'button';
      bullet.className = 'tolstoy-two-col__bullet';
      bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      bullet.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      bullet.addEventListener('click', function () {
        scrollToIndex(grid, i);
        setActive(grid, bulletsWrap, i);
        updateActivePlayback(root, grid, i);
      });
      bulletsWrap.appendChild(bullet);
    });

    display.appendChild(grid);
    setupAudioToggleDelegation(grid);
    root._ttcSlides = slides;
    attachScrollHandlers(grid, bulletsWrap, root);
    setupMobileCarousel(grid, bulletsWrap, root, slides.length);
    setActive(grid, bulletsWrap, 0);
    updateActivePlayback(root, grid, 0);
  }

  function teardownHiddenSource(sourceMount) {
    // The hidden Tolstoy widget only exists so extractSlides() can read its data out of the
    // DOM. Once we've got what we need (see the maxCards / widgetReady gating in initOne) we
    // fully remove it — not just pause its videos — so the browser aborts any in-flight
    // network/decode work and reclaims the memory. This is safe because extraction only ever
    // completes once per section; nothing later in this script reads from this DOM again.
    var wrap = sourceMount.closest('.tolstoy-two-col__source') || sourceMount;
    wrap.remove();
  }

  function initOne(sectionEl) {
    var publishId = (sectionEl.getAttribute('data-publish-id') || '').trim();
    if (!publishId) return;

    var productId = sectionEl.getAttribute('data-product-id') || '';
    var sourceMount = qs(sectionEl, '.tolstoy-carousel-container');
    if (!sourceMount) return;

    var carousel = createTolstoyCarousel(publishId, productId);
    sourceMount.innerHTML = '';
    sourceMount.appendChild(carousel);

    var maxCards = Number(sectionEl.getAttribute('data-max-cards')) || 0;
    var rendered = false;
    var widgetReady = false;

    function finish(slides) {
      if (rendered) return;
      rendered = true;
      window.clearInterval(poll);
      render(sectionEl, slides);
      teardownHiddenSource(sourceMount);
    }

    // "Enough" means: we hit the merchant's max-cards target (no need to wait for Tolstoy to
    // finish loading anything past that), or Tolstoy itself says it's done (tolstoyWidgetReady)
    // and we have at least something, or we're forcing a final read (timeout fallback).
    function attempt(widgetIsReady) {
      var slides = clampMax(extractSlides(carousel), maxCards);
      var haveTarget = maxCards > 0 && slides.length >= maxCards;
      if (haveTarget || (widgetIsReady && slides.length)) {
        finish(slides);
        return true;
      }
      return false;
    }

    var tries = 0;
    var maxTries = 60;
    var poll = window.setInterval(function () {
      tries++;
      if (attempt(widgetReady)) return;
      if (tries >= maxTries) {
        window.clearInterval(poll);
        finish(clampMax(extractSlides(carousel), maxCards));
      }
    }, 100);

    window.addEventListener('tolstoyWidgetReady', function () {
      widgetReady = true;
      attempt(true);
    });
  }

  function initAll() {
    var sections = qsa(document, '.tolstoy-two-col');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(initOne);
      return;
    }

    // Defer the whole widget (and everything it loads) until the section is getting close to
    // the viewport, so a below-the-fold carousel doesn't compete with above-the-fold content
    // for bandwidth on first load. 800px keeps it feeling instant by the time it's scrolled to.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initOne(entry.target);
        });
      },
      { rootMargin: '800px 0px' }
    );

    sections.forEach(function (sectionEl) {
      observer.observe(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
